import { render, staticRenderFns } from "./ContentLegend.vue?vue&type=template&id=469ac599&scoped=true"
import script from "./ContentLegend.vue?vue&type=script&lang=js"
export * from "./ContentLegend.vue?vue&type=script&lang=js"
import style0 from "./ContentLegend.vue?vue&type=style&index=0&id=469ac599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ac599",
  null
  
)

export default component.exports